import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tabs, Tab } from '@mui/material';

const ViewTab = ({ prefix, value, searchParams }) => (
  <Tab
    label={value.toUpperCase()}
    value={value}
    to={`${prefix}/${value}?${searchParams.toString()}`}
    component={Link}
  />
);

const StagingTabs = ({ searchParams, buildingId, view }) => {
  const prefix = buildingId ? `/staging/${buildingId}` : '/staging';

  return (
    <Tabs textColor="secondary" indicatorColor="secondary" value={view}>
      <ViewTab prefix={prefix} searchParams={searchParams} value="overview" />
      <ViewTab prefix={prefix} searchParams={searchParams} value="devices" />
      <ViewTab prefix={prefix} searchParams={searchParams} value="equipment" />
      <ViewTab prefix={prefix} searchParams={searchParams} value="points" />
      <ViewTab prefix={prefix} searchParams={searchParams} value="locations" />
    </Tabs>
  );
};
const mapStateToProps = (state) => {
  const {
    entities: {
      buildings: { byId: buildingsById },
    },
    users: { orgsById },
  } = state;
  return {
    buildingsById,
    orgsById,
  };
};

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StagingTabs);
